import CommunicationManager from "./CommunicationManager";

// NOTE: height-update is intentionally ONLY sent for feedback flows (survey
// modes size their container to the form). A shrink-to-fit attempt for the
// v4 widget home (2026-07-16) was reverted the same day: the home's content
// loads asynchronously (home widgets, news, help center), so the reported
// height stair-stepped upward on every load and the widget frame visibly
// jumped while opening, clipping the tab bar mid-resize. If shrink-to-fit
// comes back, it must wait for the home content to fully settle and resize
// at most once.
export default class HeightUpdateManager {
    private static _instance: HeightUpdateManager;
    private lastHeight: number = -1;

    static getInstance() {
        if (!this._instance) {
            this._instance = new HeightUpdateManager();
        }
        return this._instance;
    }

    constructor() { }

    sendHeight() {
        // Surveys 2.0 card/page renderer marks its measured root; legacy
        // feedback flows keep measuring .feedback-flow.
        const feedbackFlowElement = (document.querySelector(".sv2-measure") ??
            document.querySelector(".feedback-flow")) as HTMLElement;
        if (feedbackFlowElement) {
            const height = feedbackFlowElement.offsetHeight;
            if (height && height !== this.lastHeight && height > 0) {
                CommunicationManager.getInstance().sendMessage({
                    name: "height-update",
                    data: height,
                });
            }
            this.lastHeight = height;
        }
    }

    start() {
        if (window.self === window.top) {
            return;
        }

        this.sendHeight();
        window.addEventListener("resize", this.sendHeight.bind(this));
        var observer = new MutationObserver(this.sendHeight.bind(this));
        var config = { attributes: true, childList: true, characterData: true, subtree: true };
        observer.observe(window.document, config);
    }
}
